var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.category)?_c('div',{staticClass:"category-title"},[(!_vm.category.metaData.category_info.HIDE_TITLE)?_c('h2',{staticClass:"pt-2 profile-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(!_vm.category.metaData.category_info.HIDE_TITLE && _vm.subtitle)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.subtitle)}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }